import "./Biography.css";





const  Biography = () =>{
    return(
        <div className="biography" id="biography1">
        <nav>
            <h1 data-aos="zoom-in">BIOGRAPHY</h1>
            <div className="fake1" data-aos="zoom-in"></div>
            <ul data-aos="fade-right">
                <li>
                    <p>Self independent, reliable and friendly individual who works hard to achieve his goal.</p>
                </li>
                <li>
                    <p>Adaptable quickly and organized well. Interested in learning the latest web and software
                        technology quickly.</p>
                </li>
                <li>
                    <p>Able to work well in teams as well as individually. My future goal is to become a senior full
                        stack developer.</p>
                </li>
            </ul>
        </nav>
        <div className="box" data-aos="fade-right">
            <button id="name"> Name : chetanya pathak</button>
            <button id=" email"> Email : chetanyapathak6@gmail.com</button>
            <button id="address">Address : Aligarh, Uttar pradesh</button>
            <button id="phone">Phone : 9058656092</button>
            <button id="age">Age : 19 years</button>
            <button id="experience"> Experience : 0 years</button>
        </div>
        <button id="cv" data-aos="zoom-in">
            <a href="https://drive.google.com/file/d/1TMOHXUy7_TpZPHFRgXz9VtLx9WhSDxTJ/view?usp=drivesdk">Download Resume</a>
            </button>
        </div>
    )
}

export default Biography